import { render, staticRenderFns } from "./moreOverea.vue?vue&type=template&id=6ee785a8&"
import script from "./moreOverea.vue?vue&type=script&lang=js&"
export * from "./moreOverea.vue?vue&type=script&lang=js&"
import style0 from "./moreOverea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports